import { useApiClient } from '../composables/useApiClient.ts';

export default {
    getTaxSummaryByPeriod(period: string) {
        return useApiClient().post('bookkeepings/evidences/closed-months/tax-summary/by-period', { period });
    },
    getInvoiceSummaryByPeriod(period: string) {
        return useApiClient().post('bookkeepings/invoices/summary/by-period', { period });
    },
    exists(year: number, month: number) {
        return useApiClient().get('bookkeepings/evidences/closed-months/exists', { params: { year, month } });
    },
};
